import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import HolidayBanner from '../HolidayBanner';
import BirthdayCelebration from '../BirthdayCelebration';
import CommandPalette from '../CommandPalette';
import OnboardingTour from '../OnboardingTour';

export const Layout: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-white selection:bg-green-500 selection:text-slate-950">
      <Navbar />
      <div className="pt-16">
        <HolidayBanner />
      </div>
      <main>
        <Outlet />
      </main>
      <Footer />
      <CommandPalette />
      <OnboardingTour />
      <BirthdayCelebration />
    </div>
  );
};

